import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API = `${BACKEND_URL}/api`;

function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
}

// Cookie-based auth: send credentials, attach CSRF token on mutations.
export const portalApi = axios.create({
    baseURL: PORTAL_API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

portalApi.interceptors.request.use((config) => {
    const method = (config.method || "get").toLowerCase();
    if (!["get", "head", "options"].includes(method)) {
        const csrf = getCookie("client_csrf");
        if (csrf) config.headers["X-CSRF-Token"] = csrf;
    }
    return config;
});

export function formatPortalError(err, fallback = "Something went wrong.") {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    }
    return String(detail);
}
